<!-- Full page wrapper -->
<div class="min-h-screen bg-slate-50 flex justify-center sm:pb-20">
  <div
    class="w-full max-w-md bg-white min-h-screen sm:min-h-[calc(100vh-2rem)] sm:mt-8 sm:rounded-3xl sm:shadow-2xl sm:border border-slate-200 overflow-hidden relative flex flex-col">

    <!-- Header background decor -->
    <div
      class="absolute top-0 inset-x-0 h-64 bg-gradient-to-br from-indigo-50 via-blue-50/50 to-white -z-10 rounded-b-[3rem]">
    </div>

    <!-- Header -->
    <div class="sticky top-0 z-20 bg-white/60 backdrop-blur-xl shadow-sm border-b border-white/40">
      <div class="flex items-center gap-3 px-5 py-4">
        <button (click)="toBack()"
          class="flex items-center justify-center w-10 h-10 rounded-2xl bg-white/50 hover:bg-white border border-slate-100/50 shadow-sm transition-all text-slate-700 active:scale-95">
          <span class="material-symbols-outlined" style="font-size: 1.25rem;">arrow_back</span>
        </button>
        <h2 class="text-[15px] font-bold text-slate-800 tracking-tight">{{ 'ยืนยันอีเมล' | translate : 'verify-email' }}</h2>
      </div>
    </div>

    <!-- Content -->
    <div class="flex-1 overflow-y-auto w-full px-5 pt-8 pb-10">

      <!-- Icon & Title -->
      <div class="text-center mb-8">
        <div
          class="inline-flex items-center justify-center w-20 h-20 rounded-[1.5rem] bg-gradient-to-br from-indigo-600 to-blue-600 shadow-lg shadow-indigo-500/30 mb-5 relative overflow-hidden group">
          <div class="absolute inset-0 bg-white/20 blur-xl group-hover:bg-white/30 transition-colors"></div>
          <span class="material-symbols-outlined text-white relative z-10"
            style="font-size: 2.5rem;">mark_email_read</span>
        </div>
        <h1 class="text-3xl font-black text-slate-900 tracking-tight">{{ 'ตรวจสอบอีเมล' | translate : 'verify-email' }}</h1>
        <p class="mt-2 text-sm font-medium text-slate-500">{{ 'เราได้ส่งรหัส 6 หลักไปยัง' | translate : 'verify-email' }}</p>
        <div
          class="mt-1.5 inline-block bg-blue-50 text-[15px] font-bold text-blue-700 px-4 py-1.5 rounded-full border border-blue-100 shadow-sm">
          {{refItem?.email}}</div>
      </div>

      <!-- Card -->
      <div class="bg-white rounded-3xl shadow-[0_8px_30px_rgba(0,0,0,0.06)] border border-slate-100/60 overflow-hidden">

        <!-- Card Header -->
        <div class="bg-gradient-to-r from-indigo-600 to-blue-600 px-6 py-5 relative overflow-hidden">
          <div class="absolute -right-4 -top-4 w-24 h-24 bg-white/10 rounded-full blur-xl"></div>
          <p class="text-white font-bold text-[15px] relative z-10">{{ 'กรอกรหัส OTP' | translate : 'verify-email' }}</p>
          <p class="text-indigo-100 text-xs font-medium mt-1 relative z-10">{{ 'รหัสมีอายุ 30 นาที' | translate : 'verify-email' }}</p>
        </div>

        <!-- OTP Section -->
        <div class="p-6">

          <div
            class="flex justify-center [&_.otp-input]:!w-10 [&_.otp-input]:!h-12 [&_.otp-input]:!rounded-xl [&_.otp-input]:!text-xl [&_.otp-input]:!font-black [&_.otp-input]:!text-slate-800 [&_.otp-input]:!bg-slate-50 [&_.otp-input]:!border [&_.otp-input]:!border-slate-200 [&_.otp-input:focus]:!bg-white [&_.otp-input:focus]:!border-indigo-500 [&_.otp-input:focus]:!ring-4 [&_.otp-input:focus]:!ring-indigo-500/10 [&_.otp-input]:transition-all">
            <ng-otp-input [config]="{ length: 6, allowNumbersOnly: true }" (onInputChange)="onOtpChange($event)">
            </ng-otp-input>
          </div>

          <!-- Verify Button -->
          <button
            class="mt-8 w-full rounded-2xl py-4 text-[15px] font-bold transition-all flex items-center justify-center gap-2"
            [ngClass]="{
              'bg-slate-100 text-slate-400 cursor-not-allowed': otp.length != 6,
              'bg-slate-900 text-white hover:bg-black active:scale-[0.98] shadow-lg shadow-black/10': otp.length == 6
            }" (click)="verify()">
            {{ 'ยืนยันอีเมล' | translate : 'verify-email' }}
            @if(otp.length == 6) {
            <span class="material-symbols-outlined text-[18px]">verified</span>
            }
          </button>

          <!-- Timer -->
          <div class="mt-6 flex items-center justify-center gap-2">
            @if(!expired) {
            <div class="flex items-center gap-2 bg-amber-50 px-4 py-2 rounded-full border border-amber-100">
              <span class="material-symbols-outlined text-amber-500" style="font-size: 1.1rem;">timer</span>
              <span class="font-mono font-bold text-amber-700 text-sm tracking-wider">{{ remainText$ | async }}</span>
              <span
                class="text-[11px] font-bold text-amber-600/70 uppercase tracking-widest ml-1">{{ 'รับรหัสใหม่ได้ใน' | translate : 'verify-email' }}</span>
            </div>
            } @else {
            <button (click)="getOTP()"
              class="flex items-center gap-2 text-[13px] font-bold text-blue-600 hover:text-blue-700 bg-blue-50 hover:bg-blue-100 rounded-full px-5 py-2.5 transition-all w-full justify-center">
              <span class="material-symbols-outlined text-[18px]">refresh</span>
              {{ 'ส่่งรหัสใหม่อีกครั้ง' | translate : 'verify-email' }}
            </button>
            }
          </div>

        </div>
      </div>

      <!-- Help note -->
      <div class="mt-6 bg-slate-50 border border-slate-100 rounded-2xl p-4 flex gap-3 items-start">
        <div
          class="w-8 h-8 rounded-full bg-white shadow-sm flex items-center justify-center shrink-0 border border-slate-200">
          <span class="material-symbols-outlined text-slate-400" style="font-size: 1.1rem;">mark_email_unread</span>
        </div>
        <div class="text-[11px] font-medium text-slate-500 leading-relaxed mt-0.5">
          {{ 'หากไม่ได้รับอีเมล กรุณาตรวจสอบในกล่อง' | translate : 'verify-email' }} <strong class="text-slate-700">{{ 'จดหมายขยะ (Spam)' | translate : 'verify-email' }}</strong> {{ 'หรือ' | translate : 'verify-email' }} <strong
            class="text-slate-700">Junk mail</strong> {{ 'ของท่าน' | translate : 'verify-email' }}
        </div>
      </div>

    </div>
  </div>
</div>